import React from 'react';
import { AgreementActionIcon } from 'assets/icons/AgreementActionIcon';

export const SignIn = () => (
  <div>
    <AgreementActionIcon />
  </div>
);
